import { Component, EventEmitter, Input, Output } from "@angular/core";
import { VendorFeedback } from "../../../../core/models/vendor/summary/vendorFeedback";
import { CommonModule } from "@angular/common";
import { RatingModule } from "primeng/rating";
import { FormsModule } from "@angular/forms";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { ScrollPanelModule } from "primeng/scrollpanel";

@Component({
  selector: "jni-vendor-feedback-rating",
  templateUrl: "./vendor-feedback-rating.component.html",
  styleUrls: ["./vendor-feedback-rating.component.scss"],
  imports: [
    ScrollPanelModule,
    CommonModule,
    RatingModule,
    FormsModule,
    HidedynamicsdatePipe,
  ],
})
export class VendorFeedbackRatingComponent {
  @Input() vendorFeedbackObject: VendorFeedback[] = [];
  @Input() vendorFeedbackHeading = "";
  @Input() disabledToggle = false;
  @Output() vendorFeedbackEvent = new EventEmitter<VendorFeedback>();

  getRating(score: string | null) {
    return parseInt(score ?? "0");
  }

  getScore(score: string | null) {
    return parseInt(score ?? "0");
  }

  onDisabledFeedback(event: MouseEvent, vendorFeedback: VendorFeedback) {
    const target = event.target as HTMLInputElement;
    vendorFeedback.isVisible = target?.checked;
    this.vendorFeedbackEvent.emit(vendorFeedback);
  }
}
